import { Injectable } from '@angular/core';
import { environment } from "../../../../environments/environment";
import * as _ from 'lodash';
import { Observable,of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService, BudgetType, CacheService, IBudgetBO, IBudgetCommentBO, IBudgetTrackingBO, ITypeBudgetExpenseBO, ITypeBudgetStatusBO, ITypeStatusBudgetBO } from '@mapfre-tech/amap3';
import { Router } from '@angular/router';
import { map, tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})

export class BudgetService {

  className = 'BudgetService';

  sections = [
    'administration'
  ]

  constructor(private http: HttpClient, private authService: AuthService, private router: Router, private cacheService: CacheService) { }

  getAllBudget(orgStructId = '', exercise = null): Observable<IBudgetBO[]> {
    if (orgStructId === '') {
      orgStructId = this.authService.getUserMainSO()[0].idOrganizationalStructurePk
    }
    const params: any = {};
    if (exercise) {
      params.exercise = exercise;
    }
    return this.http.get<IBudgetBO[]>(environment.base_URL + `/budgets/os/${orgStructId}`, { params }).pipe(map(res => {
      return _.filter(res, it => it.nmrExercise === exercise);
    }));
  }

  getAllByAuthUser(params: any): Observable<IBudgetBO[]> {
    return this.http.get<IBudgetBO[]>(environment.base_URL + `/budgets`,{params})
  }
  getGrouped() {
    return of([
      { name: 'FILTERS.YES', value: true },
      { name: 'FILTERS.NO', value: false }
    ]);
  }

  getBudgetById(budgetId: number, changeToEuro = false): Observable<IBudgetBO[]> { //changeToEuro 
    const end = changeToEuro ? '?changeToEuro=true' : '';
    return this.http.get<IBudgetBO[]>(environment.base_URL_GAIA + `/budget/${budgetId}` + end)
  }

  getBudgetTemplate(orgStructId = '', exercise: any = null): Observable<IBudgetBO[]> {

    const params = new HttpParams().set('exercise', exercise);

    if (orgStructId === '') {
      orgStructId = this.authService.getUserMainSO()[0].idOrganizationalStructurePk
    }
    return this.http.get<IBudgetBO[]>(environment.base_URL + `/budgets/template/${orgStructId}`, { params: params })
  }

  newBudget(budget: IBudgetBO) {
    return this.http.post(environment.base_URL + "/budgets", budget);
  }

  updateBudget(editedBudget: IBudgetBO, budgetId: number) {
    return this.http
      .put(environment.base_URL + `/budgets/${budgetId}`, editedBudget)
  }

  statusBudgetType(cache = true, cacheKey = "budgetType"): Observable<ITypeStatusBudgetBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeStatusBudgetBO[]>;
    } else {
      const observable = this.http.get<ITypeStatusBudgetBO[]>(environment.base_URL + `/budgets/types`).pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getBudgetTracking(budgetId: number, changeToEuro = false): Observable<IBudgetTrackingBO[]> {
    const end = changeToEuro ? '?changeToEuro=true' : '';
    return this.http.get<IBudgetTrackingBO[]>(environment.base_URL_GAIA + `/budget_tracking/${budgetId}` + end)
  }

  updateBudgetTracking(editedBudget: IBudgetTrackingBO, budgetId: number) {
    return this.http
      .put(environment.base_URL + `/budgets/${budgetId}`, editedBudget)
  }

  newComment(comment: IBudgetCommentBO, idBudget: number): Observable<IBudgetCommentBO> {
    return this.http.post<IBudgetCommentBO>(environment.base_URL + `/budgets/comment/${idBudget}`, comment);
  }

  /**
   *  Budget Types
   */

  getAllBudgetTypes(cache = true, cacheKey = "budgetStatusTypes"): Observable<ITypeBudgetStatusBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeBudgetStatusBO[]>;
    } else {
      const observable = this.http.get<ITypeBudgetStatusBO[]>(environment.base_URL + "/budget-status-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newBudgetType(language: ITypeBudgetStatusBO) {
    return this.http.post(environment.base_URL + "/budget-status-types", language).pipe(tap(() => this.deleteBudgetTypesCache()))
  }

  updateBudgetType(language: ITypeBudgetStatusBO, id: number) {
    return this.http.put(environment.base_URL + `/budget-status-types/${id}`, language).pipe(tap(() => this.deleteBudgetTypesCache()))
  }

  private deleteBudgetTypesCache() {
    this.cacheService.deleteCache('budgetStatusTypes');
    this.cacheService.deleteCache('budgetType');
  }

  /**
 *  Budget Expenses
 */

  getAllExpensesBudgetTypes(cache = true, cacheKey = "budgetExpenseTypes"): Observable<ITypeBudgetExpenseBO[]> {
    const isAdminSection = _.some(this.sections, section => _.includes(this.router.url, section));
    cacheKey = cacheKey+"_"+isAdminSection.toString()
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeBudgetExpenseBO[]>;
   } else {
      const observable = this.http.get<ITypeBudgetExpenseBO[]>(environment.base_URL + "/budget-expense-types").pipe(map((res) => {
         if(isAdminSection){
            this.cacheService.updateCacheData(res, cacheKey)
            return res;
         }else{
            const filtrado =  _.filter(res, it => it.mrkActive);
            this.cacheService.updateCacheData(filtrado, cacheKey)
            return filtrado;
         }
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable as object as Observable<ITypeBudgetExpenseBO[]>;
   }
  }

  

  newBudgetExpensesType(language: ITypeBudgetExpenseBO) {
    return this.http.post(environment.base_URL + "/budget-expense-types", language).pipe(tap(() => this.cacheService.deleteCache('budgetExpenseTypes')))
  }

  updateBudgetExpensesType(language: ITypeBudgetExpenseBO, id: number) {
    return this.http.put(environment.base_URL + `/budget-expense-types/${id}`, language).pipe(tap(() => this.cacheService.deleteCache('budgetExpenseTypes')))
  }
}
